import useSWR from 'swr';

import client from '@/lib/feathers';

const useUser = () => {
  const swrResult = useSWR('user', async () => {
    const auth = await client.reAuthenticate();
    return auth.user;
  });
  return { user: swrResult.data, ...swrResult };
};

export default useUser;
